import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { ChargeService } from 'src/app/services/charge/charge.service';
import { InspectionChargesModalService } from 'src/app/services/inspection-charges-modal/inspection-charges-modal.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-add-edit-inspection-charges',
  templateUrl: './add-edit-inspection-charges.component.html',
  styleUrls: ['./add-edit-inspection-charges.component.scss']
})
export class AddEditInspectionChargesComponent extends DestructorComponent implements OnInit {

  @Output() inspectionChargeAdded = new EventEmitter<void>();
  @Output() inspectionChargeUpdated = new EventEmitter<void>();
  @Input() type:string;

  inspectionChargeForm!: FormGroup;
  isLoading = false;
  isEditMode = false;
  selectedInspectionCharge: any = null;

  constructor(
    private fb: FormBuilder,
    private _chargeService: ChargeService,
    private _inspectionChargesModalService: InspectionChargesModalService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeForm();
    this.setupModalListener();
  }

  private initializeForm(): void {
    console.log("type is a goood thing to check ----->",this.type)
    this.inspectionChargeForm = this.fb.group({
      name: ['', [Validators.required]],
      charge: [0, [Validators.required, Validators.min(0)]],
      type: [this.type] // Hidden field with default value
    });
  }

  private setupModalListener(): void {
    this.subscriptions.push(
      this._inspectionChargesModalService.selectedInspectionCharge$.subscribe(inspectionCharge => {
        this.selectedInspectionCharge = inspectionCharge;
        this.isEditMode = !!inspectionCharge;

        if (this.isEditMode && inspectionCharge) {
          this.populateForm(inspectionCharge);
        } else {
          this.resetForm();
        }
      })
    );
  }

  private populateForm(inspectionCharge: any): void {
    this.inspectionChargeForm.patchValue({
      name: inspectionCharge.name || '',
      charge: inspectionCharge.charge || 0,
      type: this.type
    });
  }

  private resetForm(): void {
    this.inspectionChargeForm.reset();
    this.inspectionChargeForm.patchValue({
      name: '',
      charge: 0,
      type: this.type
    });
  }

  // Form getters for validation
  get name() { return this.inspectionChargeForm.get('name'); }
  get charge() { return this.inspectionChargeForm.get('charge'); }

  private closeModal(): void {
    const modalElement = document.getElementById('kt_modal_inspection_charge_add_edit');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  onSubmit(): void {
    if (this.inspectionChargeForm.valid && !this.isLoading) {
      this.isLoading = true;

      const formData = this.inspectionChargeForm.value;

      // Remove empty fields
      const submitData: any = {};
      Object.keys(formData).forEach(key => {
        if (formData[key] !== null && formData[key] !== '') {
          submitData[key] = formData[key];
        }
      });

      const apiCall = this.isEditMode
        ? this._chargeService.UpdateData(this.selectedInspectionCharge._id, submitData)
        : this._chargeService.AddData(submitData);

      this.subscriptions.push(
        apiCall.subscribe({
          next: (response) => {
            if (response.status) {
              Swal.fire({
                title: 'Success!',
                text: `Inspection charge ${this.isEditMode ? 'updated' : 'added'} successfully.`,
                icon: 'success',
                confirmButtonText: 'OK'
              });

              if (this.isEditMode) {
                this.inspectionChargeUpdated.emit();
              } else {
                this.inspectionChargeAdded.emit();
              }

              this.closeModal();
            } else {
              Swal.fire({
                title: 'Error!',
                text: response.message || `Failed to ${this.isEditMode ? 'update' : 'add'} inspection charge.`,
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
            this.isLoading = false;
          },
          error: (error) => {
            console.error(`Error ${this.isEditMode ? 'updating' : 'adding'} inspection charge:`, error);
            Swal.fire({
              title: 'Error!',
              text: `An error occurred while ${this.isEditMode ? 'updating' : 'adding'} the inspection charge.`,
              icon: 'error',
              confirmButtonText: 'OK'
            });
            this.isLoading = false;
          }
        })
      );
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.inspectionChargeForm.controls).forEach(key => {
        this.inspectionChargeForm.get(key)?.markAsTouched();
      });
    }
  }
}
